export default "__VITE_ASSET__aGzLH2wj__"